import battery from './battery.png';
import bookmark from './bookmark.png';
import calender from './calender.png';
import home from './home.png';
import energy from './energy.png';
import smiley from './smiley.png';
import star from './star.png';
import service from './service';
import chat from './chat';
import shortcuts from './shortcuts';
import community from './community';
import gold from './gold';
import platinum from './platinum';
import silver from './silver';
import contact from './contact';
import ensemble from './ensemble';
import newsletter from './newsletter';
import search from './search';
import normal from './normal';
import warning from './warning';
import badge from './badge';
import store from './store';
import commercial from './commercial';
import envoyNotReporting from './envoy_issue2.svg';
import normalIcon from './Normal.svg';
import storage from './storage_issue2.svg';
import micro from './micro_issue2.svg';
import production from './production_issue2.svg';
import critical from './critical';
import documentation from './documentation';
import systemConfigurator from './systemConfigurator';
import training from './training';
import brandLibrary from './brandLibrary';
import leads from './leads';
export default {
  battery,
  bookmark,
  calender,
  home,
  energy,
  smiley,
  star,
  service,
  chat,
  shortcuts,
  community,
  commercial,
  critical,
  contact,
  ensemble,
  newsletter,
  search,
  warning,
  normal,
  badge,
  envoyNotReporting,
  normalIcon,
  store,
  storage,
  micro,
  production,
  gold,
  platinum,
  silver,
  documentation,
  systemConfigurator,
  training,
  brandLibrary,
  leads
};
